import React from 'react';

export const LoadingIndicator = () => (
    <div className="flex flex-col items-center justify-center p-20 space-y-4">
        <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-slate-700"></div>
        <span className="text-sm text-slate-400 font-medium animate-pulse">Processing...</span>
    </div>
);